import { createContext } from 'react'
import { NewslettersCtxTypes } from './newslettersCtx.interface'

const newslettersCtx = createContext<NewslettersCtxTypes>({
  content: null,
  emailGreeting: null,
  newsletterProducts: [],
  searchValue: '',
  emailImage: undefined,
  emailImageUrl: null,
  isEditNewsletter: false,
  existingFiles: [],
  getter: {
    campaignName: '',
    emailSubject: '',
    emailTemplate: '',
    selectedNewsletterId: 0,
    selectedNewsletterProducts: [],
    newsletterFiles: []
  },
  setter: {
    setCampaignName: () => {},
    setEmailSubject: () => {},
    setContent: () => {},
    setEmailTemplate: () => {},
    setEmailGreeting: () => {},
    setNewsletterProducts: () => {},
    setSelectedNewsletterProducts: () => {},
    setNewsletterFiles: () => {},
    setEmailImage: () => {},
    setEmailImageUrl: () => {},
    setIsEditNewsletter: () => {},
    setExistingFiles: () => {},
    setSelectedNewsletterId: () => {}
  },
  onSearchValueChangeHandler: () => {},
  onSelectedNewsletterProductsHandler: () => {},
  onRemoveProductHandler: () => {},
  onClearSelectedNewsletterProductsHandler: () => {},
  onResetNewsletterHandler: () => {}
})

export default newslettersCtx
